export default "__VITE_ASSET__CTxPtx3T__"